import { z } from "zod";
import { quantityZodSchema } from "../units-and-quantities/quantity";
import { optionalZodSchema } from "./optional";
import { optionalPercentageZodSchema } from "./optional-percentage";

const optionalUnionZodSchema = z.discriminatedUnion("_type", [
    optionalPercentageZodSchema,
    optionalZodSchema,
]);

const pickedOptionalZodSchema = z.object({
    optional: optionalUnionZodSchema,
    quantity: quantityZodSchema,
});

type PickedOptional = z.infer<typeof pickedOptionalZodSchema>;

export { optionalUnionZodSchema, pickedOptionalZodSchema };
export type { PickedOptional };
